import { render } from "./Companies.vue?vue&type=template&id=0c728855&scoped=true&ts=true"
import script from "./Companies.vue?vue&type=script&lang=ts"
export * from "./Companies.vue?vue&type=script&lang=ts"

import "./Companies.vue?vue&type=style&index=0&id=0c728855&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c728855"]])

export default __exports__